import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';

export default class OverPostedSpeedTooltip extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['caution', 'warning'])
  }

  static overPostedSpeedTypes = {
    caution: {
      helpTextKey: 'page.admin.form.videoAndDriver.overPostedSpeed.caution.help',
      signImageKey: 'resource.admin.form.videoAndDriver.overPostedSpeed.caution.signImage',
      defaultSignImage: 'pspeedcaution.svg'
    },
    warning: {
      helpTextKey: 'page.admin.form.videoAndDriver.overPostedSpeed.warning.help',
      signImageKey: 'resource.admin.form.videoAndDriver.overPostedSpeed.warning.signImage',
      defaultSignImage: 'pspeedwarning.svg'
    }
  }

  getTooltipContent() {
    const {type} = this.props;
    let overPostedSppedInfo = OverPostedSpeedTooltip.overPostedSpeedTypes[type];

    if (!overPostedSppedInfo) {
      overPostedSppedInfo = OverPostedSpeedTooltip.overPostedSpeedTypes.caution;
    }

    const helpText = I18n.t(overPostedSppedInfo.helpTextKey);
    let signImage = I18n.t(overPostedSppedInfo.signImageKey, overPostedSppedInfo.defaultSignImage);
    signImage = require(`../../../images/${signImage}`);

    return (
      <Grid container spacing={8} alignItems="center" className="admin__fieldinfo-postedspeedcont">
        <Grid item xs={9}>
          {helpText}
        </Grid>

        <Grid item xs={3}>
          <img src={signImage} className="admin__fieldinfo-postedspeedicon" />
        </Grid>
      </Grid>
    );
  }

  render() {
    return (
      <Tooltip title={this.getTooltipContent()} >
        {this.props.children}
      </Tooltip>
    );
  }
}
